<template>
    <div class="container-fluid m-0 p-0">

        <div class="row m-0">
                <!-- :logo="G.systemData.logo?.value || ''" -->
            <div class="col main-content px-sm-0">

                <Navbar :categories="categories" :data="menu_list" :TR="TR" :langs="langs" />
                <OffCanvas />

                <main class="main pt-100" style="min-height: 900px;">

                    <keep-alive>
                        <component :is="loadPages" :data="currentComponent"></component>
                    </keep-alive>

                </main>

                <Footer id="footer_section" :data="menu_list" :TR="TR" class="fixed-bottom1 p-2 p-sm-0" />

            </div>
        </div>

    </div>
</template>


<script>
    import { computed, defineAsyncComponent, onBeforeMount, ref, watchEffect } from "vue";

    import { useRoute } from "vue-router";
    import { useStore } from "@/store";

    import Navbar from "@/components/navbar/Navbar";
    import OffCanvas from "@/components/navbar/OffCanvas";
    import Footer from '@/components/footer/FooterBlack';

    import moment from 'moment-timezone';
    import 'moment/locale/az';

    import { G, ajax } from "@/_common";

    export default {
        name: 'MainL',
        components: {
            Navbar,
            OffCanvas,
            Footer,
            // Footer: Footer,
        },
        props: {
            data: {
                type: Object,
            },
        },
        // watch: {
        //     $route(to) {
        //     // set layout by route meta
        //     if (to.meta.layout !== undefined) {
        //         this.layout = to.meta.layout
        //     } else {
        //         this.layout = "DashboardLayout" // this is default layout if route meta is not set
        //     }
        //     },
        // },
        setup(props) {
            const store = useStore();
            // const router = useRouter();
            const route = useRoute();

            G.currentRoute = route;

            const def_lang = route.params && route.params.lang !== undefined ? route.params.lang : "az";
            store.setLang(def_lang);
            // console.log(store.getLang());

            moment.locale(def_lang);

            moment.updateLocale('az', {
                months: [
                    "Yanvar", "Fevral", "Mart", "Aprel", "May", "İyun",
                    "İyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"
                ],
                monthsShort: [
                    "Yan", "Fev", "Mar", "Apr", "May", "İyn",
                    "İyl", "Avq", "Sen", "Okt", "Noy", "Dek"
                ],
            });

            const gpage = G.current;

            const categories = ref([]);
            const menu_list = ref([]);
            const TR = ref([]);
            const langs = ref([]);

            gpage.page = (props.data && props.data.page !== undefined && props.data.page != '') ? (props.data.page || G.defaultPage) : G.defaultPage;
            gpage.data[gpage.page] = props.data ? props.data.data || "" : "";

            watchEffect(() => {
                TR.value = store.getTranslation();
                G.lang = TR.value;
            });

            onBeforeMount(async () => {
                await ajax({
                    url: store.getTranslations(),
                    success: (e) => {
                        // if (e && e.data) store.commit("setTranslations", e.data);
                        store.setTranslations(e.data);
                        // TR.value = store.getTranslation();
                        // G.lang = TR.value;
                    },
                    // error: () => {
                    //     // G.atoast.error('Server Connection Error !');
                    //     return null;
                    // }
                });

                await ajax({
                    url: store.getSystemSettings('system'),
                    success: async (x) => {
                        let res = x.data || null;
                        if ( x.status == 200 && res ) {
                            if( res.company !== undefined ){
                                for(let a in res){
                                    G.systemData[a] = {"value": res[a].value, "type": res[a].type};
                                }
                                document.getElementById("frontend_favicon1").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon2").setAttribute("href", G.systemData?.favicon?.value );
                                document.getElementById("frontend_favicon3").setAttribute("href", G.systemData?.favicon?.value );
                            }
                            else{
                                G.systemData = res;
                            }

                            // G.systemData = res.reduce((m, o) => m.set(o.key, o), new Map);
                            // console.log(G.systemData);
                            // console.log(res.reduce((m, o) => m.set(o.key, o), new Map)); //.values();
                            // console.log(res.reduce((m, o) => m.set(o.key, {"value": o.value, "type": o.type}), new Map)); //.values();
                        }
                    },
                    // error: () => {
                    //     // console.log(e);
                    // }
                });

                await ajax({
                    url: store.getLangs(),
                    success: (e) => {
                        langs.value = e.data;
                    }
                });

                await ajax({
                    url: store.getMenus(),
                    success: async (e) => {
                        menu_list.value = e.data;
                    },
                });

                const f = (d) => {
                    d.forEach(ci => {
                        if( ci.children && ci.children.length > 0 ){
                            f(ci.children);
                        }
                        // else{
                        // }
                        ci.link = `products_by_category`;
                        ci.link_param = {category_id: ci.id};
                    });
                };

                await ajax({
                    url: store.getCategoriesWithChildren(),
                    success: (e) => {
                        let cats = { link: '#', target: '', translate: {name: '<i class="fas fa-bars text-site fs-5" style=""></i>'}, children: e.data };
                        // let cats = { link: '#', target: '', translate: {name: TR.value.products}, children: e.data };
                        f(cats.children);
                        categories.value = cats;
                    }
                });
            });

            // const setComponent = (val) => {
            //     // val = val.replace(/^\//, "");
            //     // gpage.page = G.capitalize(val);

            //     // document.getElementsByTagName('body')[0].style='';

            //     gpage.page = val;
            //     gpage.data[gpage.page] = {};

            //     router.push({
            //         name: val,
            //         // params: {
            //         //     // soldier_id: route.params.soldier_id || 2,
            //         // },
            //         // params: Object.assign(
            //         //     {
            //         //         page: 1,
            //         //         perpage: prm.limit || 20,
            //         //     },
            //         //     route_obj.value
            //         // ),
            //     });
            // };

            const currentComponent = computed(() => {
                return gpage.data[gpage.page] || {};
            });

            const loadPages = computed(() => {
                return defineAsyncComponent({
                    loader: () => import(`@/${gpage.page}`),
                    errorComponent:
                        defineAsyncComponent(() =>
                            import('@/pages/NotFound')
                        ),
                    // timeout: 3000,
                    // suspensible: false,
                });
            });

            return {
                G,
                TR,
                currentComponent,
                loadPages,
                // setComponent,
                langs,
                menu_list,
                categories,
            };
        },
    };
</script>


<style lang="scss">
    /*.main-content {
        width: calc(100% - 275px);
        // height: calc( 100% - 50px );
        // max-height: calc( 100% - 90px );
        // margin-bottom: 60px;
    }
    .main {
        // height: calc( 100vh - 10px );
        max-height: calc( 100vh - 95px );
        // margin-bottom: 60px;
        overflow: hidden;
        overflow-y: scroll;
    }
    .main > .row, .main > .row > .col-12{
        margin: 0px;
        padding: 0px;
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }*/
    // .main-content {
    //     width: calc(100% - 250px);
    //     // height: calc( 100% - 50px );
    //     // max-height: calc( 100% - 90px );
    //     // margin-bottom: 60px;
    // }
    // .main-body-content {
    //     // height: calc( 100vh - 95px );
    //     // max-height: calc( 100vh - 95px );
    //     height: calc( 100vh - 79px );
    //     max-height: calc( 100vh - 79px );

    //     // margin-bottom: 60px;
    //     overflow: hidden;
    //     overflow-y: scroll;
    //     padding: 4px 0px;
    // }
    // .main-body-content > .row, .main-body-content > .row > .col-12{
    //     margin: 0px;
    //     padding: 0px;
    // }
    @media (max-width: 576px) {
        .pt-100{
            padding-top: 0px;
        }
    //     .main-content {
    //         width: 100%;
    //     }
    //     .main-body-content {
    //         height: calc( 100vh - 103px );
    //         max-height: calc( 100vh - 103px );
    //         padding: 4px 0px;
    //     }
    }
</style>

